import React from 'react';
import _ from 'lodash';
import TeamsTableRow from './TeamsTableRow';
import { useTeamsStats } from '../../../hooks/teamStats';
import { addRankingNumberWithDuplicates } from '../../../utils/functionalUtils';
import { addFormToRow } from '../../../utils/standings';
import { useMatchesMinimized } from '../../../hooks/matches';
import { useStandings } from '../../../hooks/standings';

function TeamsTable({ season, orderBy }) {
  const [teamsStats, teamsStatsLoading] = useTeamsStats(season);
  const [allMatches] = useMatchesMinimized(season);
  const [standings] = useStandings(season);

  const finishedMatches = (allMatches || []).filter(
    (match) => match.status === 'FINISHED'
  );

  const standingsObj = Object.values(standings || []).reduce(
    (acc, teamStandings) => {
      const teamAbbrv = teamStandings.teamAbbrv || teamStandings.abbrv;
      return {
        ...acc,
        [teamAbbrv]: (teamStandings.stats || []).reduce((a, s) => {
          return {
            ...a,
            [s.name]: s.value ? parseInt(s.value, 10) : 0,
          };
        }, {}),
      };
    },
    {}
  );

  const order = (() => {
    if (['goalsConceded'].includes(orderBy)) {
      return 'asc';
    }

    return 'desc';
  })();

  const teamsWithRankings = addRankingNumberWithDuplicates(
    _.orderBy(
      Object.values(teamsStats || []).map((teamStats) => {
        const teamStatsWithForm = addFormToRow(finishedMatches)(teamStats);
        const teamAbbrv = teamStats.teamAbbrv || teamStats.abbrv;
        const goalsConceded = standingsObj?.[teamAbbrv]?.ga || null;

        return {
          ...teamStatsWithForm,
          goalsConceded,
        };
      }),
      orderBy,
      order
    ),
    orderBy
  );
  if (teamsWithRankings.length && !teamsStatsLoading) {
    return teamsWithRankings
      ?.filter((x) => x.abbrv !== undefined)
      .map((team, i) => (
        <TeamsTableRow team={team} i={i + 1} orderBy={orderBy} />
      ));
  }
  if (teamsStatsLoading) {
    return (
      <div className="stats-table__row">
        <div className="col-12 text-center stats-font-larger">Loading...</div>
      </div>
    );
  }
  return (
    <div className="stats-table__row">
      <div className="col-12 text-center stats-font-larger">
        Ingen data tillgänglig.
      </div>
    </div>
  );
}
export default TeamsTable;
